import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

/**
 * Formly wrapper that renders a titled section around a field group.
 *
 * Props:
 * - `label` – string  Section heading text (displayed as an h3 or h4 based on `headingLevel`).
 * - `headingLevel` – `'h3' | 'h4'`  Defaults to `'h3'`.
 *
 * Usage:
 * ```typescript
 * {
 *   wrappers: ['field-group-section'],
 *   props: {
 *     label: 'QR Code',
 *     headingLevel: 'h4',
 *   },
 *   fieldGroupClassName: 'flex-responsive col-2',
 *   fieldGroup: [ ... ],
 * }
 * ```
 */
@Component({
  selector: 'app-field-group-section-wrapper',
  standalone: true,
  template: `
    @if (props['label']) {
      @if (props['headingLevel'] === 'h4') {
        <h4 class="section-label section-label--h4">{{ props['label'] }}</h4>
      } @else {
        <h3 class="section-label">{{ props['label'] }}</h3>
      }
    }
    <ng-container #fieldComponent></ng-container>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
    }
    .section-label {
      flex-basis: 100%;
      font-size: var(--font-size-md);
      font-weight: var(--font-weight-semibold);
      color: var(--fg-primary);
      margin: 0;
    }
    .section-label--h4 {
      font-size: var(--font-size-sm);
      color: var(--fg-secondary);
    }
  `,
})
export class FieldGroupSectionWrapperComponent extends FieldWrapper {}
